import { Component, OnInit } from '@angular/core';
import { ApiService } from 'angular-lib';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from '../../../services/loader.service';

@Component({
    selector: 'ez-email',
    template: require('./email.component.html'),
    styles: [require('./email.component.less')]
})
export class EmailComponent implements OnInit {
    public emailStatus: string = 'pending';
    public email: string = '';
    public confirmationSent: boolean = false;
    public emailResult: string = '';
    public isSuccess: boolean = false;
    public emailProvider = null;

    constructor(
        private apiService: ApiService,
        private translateService: TranslateService,
        private loaderService: LoaderService
    ) {
    }

    public ngOnInit() {
        this.loaderService.show();
        this.loadInformations();
    }

    private loadInformations() {
        this.apiService.getAccountInformations().subscribe(
            (res) => {
                if (res.email !== undefined) {
                    this.email = res.email;
                }

                this.emailProvider = null;
                if (res.emailProvider !== undefined) {
                    this.emailProvider = res.emailProvider;
                    if (!this.emailProvider.mailBoxUrlSpam) {
                        this.emailProvider.mailBoxUrlSpam = this.emailProvider.mailBoxUrl;
                    }
                }
                this.loaderService.hide();
            },
            error => {
                this.loaderService.hide();
            }
        );
    }

    public sendConfirmation() {
        this.apiService.sendConfirmationEmail().subscribe((res) => {
            if (res === true) {
                this.confirmationSent = true;
            }
        });
    }

    public save() {
        this.loaderService.show();
        this.confirmationSent = false;
        this.apiService.saveAccount({email: this.email}).subscribe((res) => {
            this.translateService.get('account.email.email-saved').subscribe((str) => {
                this.emailResult = str;
            });
            this.isSuccess = true;
            this.loadInformations();
        },
        error => {
            this.emailResult = error.message;
            this.isSuccess = false;
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/account/email/email.component.ts